import { createSlice } from "@reduxjs/toolkit";
import { addParent, getMaintenance, getSettings } from "./actions";

const initialState = {
  settings: null,
  loading: false,
  error: "",
  parentWallet: null, // Added for storing linked parent wallet

  maintenance: null,
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getSettings.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
      })
      .addCase(getSettings.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getMaintenance.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getMaintenance.fulfilled, (state, action) => {
        state.loading = false;
        state.maintenance = action.payload;
      })
      .addCase(getMaintenance.rejected, (state) => {
        state.loading = false;
      })

      .addCase(addParent.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(addParent.fulfilled, (state, action) => {
        state.loading = false;
        state.parentWallet = action.payload; // Storing in correct place
      })
      .addCase(addParent.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default settingsSlice.reducer;
